import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AppConfig } from '../app-config.loader';
import { Indirizzo } from '../shared/models/indirizzo.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaIndirizziService extends AnagraficaBaseService<Indirizzo> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaIndirizzi`);
  }
  public readonly idProperty = 'indirizzoId';
  public readonly nameProperty = 'nomeIndirizzo';

  getAllConfermati(): Observable<Indirizzo[]> {
    return this.getAll().pipe(map(indirizzi => indirizzi.filter(i => i.isConfirmed)));
  }

  getAllProvvisori(): Observable<Indirizzo[]> {
    return this.getAll().pipe(map(indirizzi => indirizzi.filter(i => !i.isConfirmed)));
  }

  cambiaindirizzo(oldId: number, newId: number): Observable<unknown> {
    return this.http.put(`${this.apiBaseUrl}/cambiaindirizzo/${oldId}`, newId).pipe(tap(() => this.reloadAll()));
  }

  hide(indirizzo: Indirizzo): Observable<Indirizzo> {
    return this.http.put<Indirizzo>(`${this.apiBaseUrl}/hide/${this.getItemId(indirizzo)}`, {}).pipe(tap(() => this.reloadAll()));
  }
}
